import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './AmexDiscoveryPrompt.scss';

const AmexDiscoveryPrompt = ({
  Analytics,
  discoveryPromptConfig,
  imagePath,
  icon,
}) => {
  if (!discoveryPromptConfig) return null;

  const {
    title,
    linkText,
    linkUrl,
    iconAriaLabel,
    analyticsActionName,
  } = discoveryPromptConfig;

  const sanitizedTitle = sanitizeString(title);
  const sanitizedLinkText = sanitizeString(linkText);
  const iconSrc = `${imagePath}${icon}`;

  return (
    <section className="AmexDiscoveryPrompt">
      <div className="container">
        <div className="AmexDiscoveryPrompt__inner">
          {icon && (
            <div className="AmexDiscoveryPrompt__iconWrapper" aria-hidden="true">
              <Icon url={iconSrc} name={iconAriaLabel} />
            </div>
          )}
          <h2
            className="AmexDiscoveryPrompt__title"
            dangerouslySetInnerHTML={{ __html: sanitizedTitle }} // eslint-disable-line react/no-danger
          />
          <p>
            <Link
              className="AmexDiscoveryPrompt__link"
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={sanitizedLinkText}
              onClick={() => {
                handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, {
                  action_name: analyticsActionName,
                });
              }}
            >
              {sanitizedLinkText}
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

AmexDiscoveryPrompt.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  discoveryPromptConfig: PropTypes.shape({
    title: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
    iconAriaLabel: PropTypes.string,
    analyticsActionName: PropTypes.string,
  }),
  imagePath: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

AmexDiscoveryPrompt.defaultProps = {
  discoveryPromptConfig: null,
  icon: '',
};

export default AmexDiscoveryPrompt;
